module.exports = __webpack_public_path__ + "media/img/tech_mobile_1-88eeeabf.png";